import type React from 'react';

import { Badge } from '@change/ds-core-ui';
import { StarIcon } from '@change/ds-icons';

import { ActionButton } from './components/ActionButton';
import { TaskDetails } from './components/TaskDetails';

type Translate = (key: string) => string;

// oxlint-disable-next-line complexity
export const getPrimaryActionText = (featureKey: string | null, translate: Translate): string => {
	switch (featureKey) {
		case 'complete_profile':
			return translate('corgi.petition.starter_dashboard_v2.next_steps.tasks.complete_profile.cta');
		case 'customize_link':
			return translate('corgi.petition.starter_dashboard_v2.next_steps.tasks.customize_link.cta');
		case 'share_friends':
			return translate('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_friends.cta');
		case 'share_communities':
			return translate('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_communities.cta');
		case 'share_social':
			return translate('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_social.cta_2');
		case 'share_facebook':
			return translate('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_facebook.cta');
		case 'share_instagram':
			return translate('corgi.petition.starter_dashboard_v2.next_steps.tasks.share_instagram.cta');
		case 'download_flyer':
			return translate('corgi.petition.starter_dashboard_v2.next_steps.tasks.download_flyer.cta');
		case 'download_signatures':
			return translate('corgi.petition.starter_dashboard_v2.next_steps.tasks.download_signatures.cta');
		case 'thank_supporters':
			return translate('corgi.petition.starter_dashboard_v2.next_steps.tasks.thank_supporters.cta');
		case 'promote_basic':
			return translate('corgi.petition.starter_dashboard_v2.next_steps.tasks.promote_basic.cta');
		default:
			return translate('corgi.petition.starter_dashboard_v2.dynamic_tasks.task.take_action');
	}
};

export const renderStartBadge = (translate: Translate) => (
	<Badge
		className="self-start"
		variant="information"
		emphasis="weaker"
		size="small"
		label={translate('corgi.petition.starter_dashboard_v2.dynamic_tasks.task.start_here_badge')}
		leadingIcon={<StarIcon className="text-icon-information !size-4" svgClassName="!size-4" />}
		data-qa="dynamic-task-start-here-badge"
	/>
);

type ExpandedContentParams = Readonly<{
	description: readonly string[];
	reasoning: string | null;
	isFirstActive: boolean;
	isCompleted: boolean;
	primaryActionText: string;
	hasCta: boolean;
	onButtonClick?: () => Promise<void>;
}>;

export const ExpandedContent: React.FC<ExpandedContentParams> = ({
	description,
	reasoning,
	isFirstActive,
	isCompleted,
	primaryActionText,
	hasCta,
	onButtonClick,
}) => (
	<div className="flex w-full min-w-0 flex-col gap-4">
		<TaskDetails description={description} reasoning={reasoning} isCompleted={isCompleted} />
		<div className="md:hidden" data-qa="dynamic-task-mobile-action">
			<ActionButton
				isFirstActive={isFirstActive}
				hasCta={hasCta}
				isCompleted={isCompleted}
				primaryActionText={primaryActionText}
				className="w-full"
				dataQaSuffix="-mobile"
				onClick={onButtonClick}
			/>
		</div>
	</div>
);
